import { render, staticRenderFns } from "./JustificationItem.vue?vue&type=template&id=dc908ebe"
import script from "./JustificationItem.vue?vue&type=script&lang=js"
export * from "./JustificationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports